<template>
  <b-row>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-col>
      <table v-if="archivos.length > 0" class="table table-sm table-default table-bordered table-striped">
        <thead>
        <tr class="table-b-table-default">
          <th>
            Nombre del archivo
          </th>
          <th>
            Acciones
          </th>

        </tr>
        </thead>
        <tbody>
        <tr v-for="archivo in archivos" :key="archivos.indexOf(archivo)">
          <td>
            {{ archivo.nombre }}
          </td>
          <td>
            <b-button-group>
              <b-button v-b-modal="'mostrar-archivo-imagen-'+archivo.idArchivo" size="sm"
                        v-if="isPdfOrImage(archivo)" variant="info">
                <font-awesome-icon icon="eye"/>
              </b-button>
              <b-modal
                  ok-title="Aceptar"
                  cancel-title="Cerrar"
                  size="xl"
                  :id="'mostrar-archivo-imagen-'+archivo.idArchivo" title="Archivo">
                <p class="my-4">
                  <MostrarArchivoPdfOImagen :archivo="archivo"></MostrarArchivoPdfOImagen>
                </p>
              </b-modal>
              <b-button  v-on:click="archivoService.descargar(archivo.idArchivo)" size="sm" v-if="!isPdfOrImage(archivo)" variant="info">
                <font-awesome-icon icon="download"/>
              </b-button>
              <b-button v-if="showDelete === true"  v-on:click="eliminar(archivo)" size="sm" variant="danger">
                <font-awesome-icon icon="times"/>
              </b-button>
            </b-button-group>
          </td>
        </tr>
        </tbody>
      </table>
      <div v-else class="">Sin documentos</div>
    </b-col>
  </b-row>

</template>

<script>
import MostrarArchivoPdfOImagen from "./MostrarArchivoPdfOImagen";
import {ArchivoService} from "../../apiServices/archivo/ArchivoService";
export default {
  name: "ListarArchivos",
  components: {MostrarArchivoPdfOImagen},
  props: {
    showDelete:{
      type:  Boolean,
      required: true,
    },
    archivos: {
      type: Array
    }
  },
  data: ()=> ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    archivoService: new ArchivoService(),
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    isPdfOrImage(archivo) {
      return archivo.mime.includes('pdf') || archivo.mime.includes('image');
    },
    eliminar(archivo){
      this.$emit('archivos', this.archivos.filter(archivoinlist => archivo.idArchivo !== archivoinlist.idArchivo))
    }
  }
}
</script>

<style scoped>
.table-b-table-default {
  color: #ffffff !important;
  background-color: #0e6ba9 !important;
}
</style>
